import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { ConveniosComponent } from "../componentes/convenios/convenios.component";
import { GestorConveniosComponent } from "../componentes/gestor-convenios/gestor-convenios.component";
import { EstadoCuentaComponent } from "../componentes/estado-cuenta/estado-cuenta.component";
import { EjecucionFiscalComponent } from "../componentes/ejecucion-fiscal/ejecucion-fiscal.component";
import { AguaBloqueosComponent } from "../componentes/agua-bloqueos/agua-bloqueos.component";
import { AltaMedidoresComponent } from '../componentes/alta-medidores/alta-medidores.component';
import { BajaDeCuentaComponent } from '../componentes/baja-de-cuenta/baja-de-cuenta.component';
import { AuthGuard } from "app/_helpers/auth.guard";



const routes: Routes = [
  {
    path: "",
    children: [
      {
        path: "convenios",
        component: ConveniosComponent,
         canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "gestor-convenios",
        component: GestorConveniosComponent,
         canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "aguas-bloqueos",
        component: AguaBloqueosComponent
        ,
        canActivate: [AuthGuard]
      }
    ]
  },
  {
    path: "",
    children: [
      {
        path: "ejecucion-fiscal",
        component: EjecucionFiscalComponent
        ,
        canActivate: [AuthGuard]
      }



    ]    
  },
 
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class FiscalizacionRoutingModule {}
